import { useNavigate } from 'react-router-dom';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { PatientsDirectory } from '../directory/PatientsDirectory';

/**
 * RCM Patients directory at scale (rcm-24, 00-ds-09 §7, D148): a compact band,
 * then one card with a filter bar, the table and numbered pages, over a big
 * deterministic mock. The default view is the patients visiting today or
 * tomorrow. Clicking a row opens that patient's insurance page.
 *
 * The page renders its own compact band, so it suppresses the shared top bar
 * (no Core-style header / chips on the directory — rcm-24 §6).
 */
export function PatientsListPage() {
  const navigate = useNavigate();
  usePageTopBar({ breadcrumb: ['Patients'], hideTopBar: true });

  return (
    <div className="pp-root relative flex min-h-0 flex-1 flex-col overflow-hidden">
      <PatientsDirectory onSelect={(id) => { void navigate(`/patients/${id}`); }} />
    </div>
  );
}
